/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from './../../controllers/Step1/step1Ctrl.module.css';
import { PRINTERLESS_METHODS, KEEP_THE_ITEM } from '../../constants/returnMethods';
import getPrinterlessInfoLink from '../../lib/getPrinterlessInfoLink';
import { retailerSettingsService } from '../../services';
import CancelReturnModal from './../CancelReturnModal';
import { Spinner } from '../../components/Spinner';
import generateMethodKey from '../../lib/generateMethodKey';
import { isNotShipped } from '../PendingReturns/utils';

const mapStateToProps = (state) => {
  const {
    language,
    itemsPage: { cancellingLabel, disableItemCancel } = {},
    page: { secureMode, locale, browserFingerprint } = {},
    retailerSettings: { name: retailer } = {},
  } = state;

  return {
    language,
    cancellingLabel,
    disableItemCancel,
    secureMode,
    locale,
    retailer,
    browserFingerprint,
  };
};

const hasPrinterlessLink = (returnMethod) => PRINTERLESS_METHODS.includes(returnMethod);

const ItemsActionsComponent = ({
  language,
  cancellingLabel,
  secureMode,
  locale,
  retailer,
  label,
  openCancelModal,
  cancelLabel,
  showButtonReprintLabel,
}) => {
  if (generateMethodKey(label) === KEEP_THE_ITEM) {
    return null;
  }

  const disableItemCancel = retailerSettingsService.getItemCancelDisabled();

  return (
    <div className={s.returned_actions_container}>
      {/* Not Shipped Actions */}
      {cancellingLabel !== label.tracking_number && isNotShipped({ label }) ? (
        <div className={s.pending_return_actions}>
          <>
            {!secureMode && (label.qr_code || hasPrinterlessLink(label.return_method)) ? (
              <span>
                <a
                  href={getPrinterlessInfoLink({
                    retailer,
                    encryptedReturnId: label.encrypted_return_id,
                    locale,
                  })}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="printerless-info-link"
                >
                  {language[`returns.step_1.${label?.return_method}_code_link_text`] ||
                    language['returns.step_1.printerless_info_link_text']}
                </a>
              </span>
            ) : null}
            {showButtonReprintLabel(label) ? (
              <span>
                <a
                  className="print-label-link"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(label.url, '_blank');
                  }}
                  href="#"
                >
                  {language['returns.step_1.reprint_label_btn']}
                </a>
              </span>
            ) : null}
            {!disableItemCancel && label.cancel_eligibility !== false ? (
              <span>
                <a
                  className="cancel-label-link"
                  onClick={(event) =>
                    label.return_method === 'local_pickup'
                      ? openCancelModal(label, event)
                      : cancelLabel(label, event)
                  }
                  href="#"
                >
                  {language[`returns.step_1.${label.return_method}.cancel_return_btn`] ||
                    language['returns.step_1.cancel_return_btn']}
                </a>
                {label.return_method === 'local_pickup' ? (
                  <CancelReturnModal label={label} onConfirmCancel={cancelLabel} />
                ) : null}
              </span>
            ) : null}
          </>
        </div>
      ) : null}
      {/* Shipped Actions */}
      {!isNotShipped({ label }) && label.return_method !== 'local_pickup' ? (
        <div>
          <a target="_blank" rel="noopener noreferrer" href={label.tracking_url || '#'}>
            {language['returns.step_1.track_return_btn']}
          </a>
        </div>
      ) : null}
      {/* Canceling Label Spinner */}
      {cancellingLabel === label.tracking_number ? (
        <div className={s.spinner_container}>
          <Spinner />
        </div>
      ) : null}
    </div>
  );
};

export default connect(mapStateToProps)(ItemsActionsComponent);

ItemsActionsComponent.defaultProps = {
  label: {},
  openCancelModal: () => {},
  cancelLabel: () => {},
  showButtonReprintLabel: () => {},
};

ItemsActionsComponent.propTypes = {
  dispatch: PropTypes.func.isRequired,
  label: PropTypes.object,
  language: PropTypes.object.isRequired,
  cancellingLabel: PropTypes.bool.isRequired,
  disableItemCancel: PropTypes.bool.isRequired,
  secureMode: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  retailer: PropTypes.string.isRequired,
  openCancelModal: PropTypes.func,
  cancelLabel: PropTypes.func,
  showButtonReprintLabel: PropTypes.func,
};
